<div class="sidenav-container">
  <div class="sidenav-content">
    <img class="logo" src="/assets/img/medtronic-academy.svg" alt="Medtronic Academy" width="248" height="17" />
    <div class="content scrollable">
      <ul class="nav-items">
        <ng-container *ngFor="let navItem of navItems">
          <li
            *ngIf="navItem.visibleForRoles | access"
            class="nav-item"
            [ngClass]="{ expanded: navItem.isExpanded || isAnyChildRouteActive(navItem) }"
            (click)="selectItem(navItem)"
          >
            <div class="nav-item-title">{{ navItem.titleKey | translate }}</div>
            <ul *ngIf="navItem.children && (navItem.isExpanded || isAnyChildRouteActive(navItem))" class="nav-subitems">
              <ng-container *ngFor="let navSubitem of navItem.children">
                <li
                  *ngIf="navSubitem.visibleForRoles | access"
                  class="nav-subitem"
                  [routerLink]="navSubitem.disabled ? null : [navSubitem.path]"
                  [routerLinkActive]="navSubitem.disabled ? '' : 'active'"
                  (click)="selectItem(navSubitem); $event.stopPropagation()"
                >
                  {{ navSubitem.titleKey | translate }}
                </li>
              </ng-container>
            </ul>
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="footer">
      <div class="hide-menu-btn-container">
        <button class="hide-menu-btn" (click)="toggle.emit()">{{ 'sidenavhidemenu' | translate }}</button>
        <button class="toggle-menu-btn-arrow" (click)="toggle.emit()"></button>
      </div>
    </div>
  </div>
</div>
